import { useEffect } from 'react';
import { useAuth } from '@smarty/shared';
import { setSentryUser, clearSentryUser } from '@/instrument';

/**
 * Sincroniza la identidad del usuario autenticado con Sentry.
 * Montar una sola vez en App.tsx dentro del AuthProvider.
 */
export function useSentryIdentify(): void {
  const { user, tenantId, userRole: role } = useAuth(); // el campo real es `userRole`

  useEffect(() => {
    if (user?.id && tenantId) {
      setSentryUser({
        id: user.id,
        tenantId,
        role: role ?? 'unknown',
        email: user.email ?? undefined,
      });
    } else {
      clearSentryUser();
    }
  }, [user?.id, user?.email, tenantId, role]);
}
